<template>
  <el-dialog
    title="Купить клики"
    :visible.sync="visible"
    width="400px"
    @close="reset"
  >
    <el-form :model="form" label-width="0">
      <el-form-item label="Пакет" label-width="70px">
        <el-select v-model="form.package_id" placeholder="Выберите пакет" style="width: 100%;">
          <el-option
            v-for="pkg in packages"
            :key="pkg.id"
            :label="pkg.label"
            :value="pkg.id"
          />
        </el-select>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">Отмена</el-button>
      <el-button
        type="primary"
        :loading="loading"
        :disabled="!form.package_id"
        @click="onBuy"
      >
        Купить
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import axios from 'axios'
import { Message, MessageBox } from 'element-ui'

export default {
  name: 'ClickPurchaseModal',
  data() {
    return {
      visible: false,
      loading: false,
      packages: [],
      form: {
        package_id: null,
      },
    }
  },
  methods: {
    open() {
      this.visible = true
      this.fetchPackages()
    },
    reset() {
      this.form.package_id = null
    },
    async fetchPackages() {
      try {
        const { data } = await axios.get('/api/admin/click-transactions/packages')
        this.packages = data.data || []
      } catch {
        Message.error('Не удалось загрузить пакеты')
      }
    },
    async onBuy() {
      if (this.loading) return
      if (!this.form.package_id) {
        Message.warning('Сначала выберите пакет')
        return
      }
      const pkg = this.packages.find(p => p.id === this.form.package_id)
      if (!pkg) {
        Message.error('Выбранный пакет не найден')
        return
      }

      try {
        await MessageBox.confirm(
          `Вы собираетесь купить ${pkg.clicks} кликов.\nС вашего баланса спишется ${pkg.cost} ₽.`,
          'Подтверждение',
          { confirmButtonText: 'Подтвердить', cancelButtonText: 'Отменить', type: 'warning', distinguishCancelAndClose: true }
        )
      } catch {
        return
      }

      this.loading = true
      try {
        const resp = await axios.post('/api/admin/click-transactions/buy', {
          package_id: this.form.package_id,
          //idempotency_key: uuidv4(),
        })

        try { await this.$store.dispatch('user/getInfo') } catch {}

        Message.success('Покупка успешна!')
        this.visible = false
        this.$emit('purchased', { clicks: resp.data.clicks, balance: resp.data.balance })
      } catch (err) {
        const msg = err.response?.data?.error || 'Ошибка покупки'
        Message.error(msg)
      } finally {
        this.loading = false
      }
    },
  }
}
</script>
